import {configureStore} from "@reduxjs/toolkit";
import analyticsReducer from "../features/analytics/AnalyticsSlice";
import configReducer from "../features/config/ConfigSlice";
import markerReducer from "../features/marker/markerSlice";
import searchFlightsReducer from "../features/searchFlights/searchFlightsSlice";

const store = configureStore({
  reducer: {
    analytics: analyticsReducer,
    config: configReducer,
    marker: markerReducer,
    searchFlights: searchFlightsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
